import { _apiServer } from "./constants.js";
export const apiServer = _apiServer;
export const sitekey = '6Ldu30UeAAAAAHJy8kwKzULubE4zPCahIcsZMP_Q';
export const whyItems = [
    { label: "Get More Clients, Increase Sales", id: "section3" },
    { label: "Stay on Top of Business", id: "section5" },
    { label: "Organize Better", id: "section6" },
    { label: "Job Done Fast, Get Paid Faster", id: "section7" },
    { label: "Increase Productivity", id: "section8" },
    { label: "Take Full Control", id: "section9" },
    { label: "Reduce Costs", id: "section10" },
    { label: "Save Time", id: "section11" },
    { label: "Increate Outreach", id: "section12" },
];
export const features = [
    { label: 'Features' },
    { label: 'Instant Quote & Online Booking', id: 'instant' },
    { label: 'Website Manager', id: 'build' },
    { label: 'Client Manager', id: 'clients' },
    { label: 'Job Manager', id: 'jobs' },
    { label: 'Crew Manager', id: 'crews' },
    { label: 'Marketing Tools', id: 'market' },
    { label: 'Payment System', id: 'paid' },
    { label: 'Reports/Analytics', id: 'analyze' },
    { label: 'Plans & Pricing', link: '/pricing' },
];
export const scrollHeights = [0, 630, 880, 2950, 3500, 4240, 5730, 6810, 7730, 7950, 9630, 10280, 12000];
export const headerScrollHeights = [880, 630, 4240, 6810, 5730, 7950, 9630, 10260];
